module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/_iterators.js
// module id = 310
// module chunks = 1